import { Account, Document } from './endpoints'
export * from './urls'

export const API = {
  Account,
  Document,
}
